<template>
  <div class="base-pagination">
    <el-pagination :page-size.sync="pageSize" :current-page.sync="currentPage" @current-change="currentChange"
                   :pager-count="5" :background="background" layout="prev, pager, next, slot" :total="total">
      <div class="base-pagination-box">
        查询到
        <i>{{ total }}</i>
        条记录，共
        <i>{{ pageTotal }}</i>
        页
      </div>
    </el-pagination>
  </div>
</template>

<script>
export default {
  name: 'BasePagination',
  props: {
    background: {
      type: Boolean,
      default: true,
    },
    total: {
      type: Number,
      default: 0,
    },
    pageSize: {
      type: Number,
      default: 18,
    },
    parentPage: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      currentPage: 1,
    }
  },
  created() {
    this.currentPage = this.parentPage
  },
  computed: {
    pageTotal() {
      return parseInt((this.total + this.pageSize - 1) / this.pageSize)
    },
  },
  methods: {
    currentChange() {
      this.$emit('currentChange', this.currentPage)
    },
  },
  watch: {
    parentPage(newVal) {
      this.currentPage = newVal
    },
  },
}
</script>

<style lang="less">
.base-pagination {
  display: inline-block !important;
  width: 100% !important;
  text-align: center !important;
  padding: 12px 20px;
  line-height: 28px;


  /deep/ .btn-prev,
  /deep/ .btn-next,
  /deep/ .number,
  /deep/ .el-icon.more {
    min-width: 28px !important;
    font-size: 14px !important;
    font-weight: 400 !important;
    color: #666 !important;
    border-radius: 4px !important;
  }


  .el-pagination.is-background /deep/ .btn-prev,
  .el-pagination.is-background /deep/ .btn-next,
  .el-pagination.is-background /deep/ .number,
  .el-pagination.is-background /deep/ .el-icon.more {
    border: 1px solid #cdcdcd !important;
    background-color: #fff !important;
  }

  /deep/ .el-pagination {
    padding: 0 !important;
  }

  /deep/ .btn-prev {
    margin-left: 0 !important;
  }

  /deep/ .btn-prev[disabled],
  /deep/ .btn-next[disabled] {
    color: #d9d9d9 !important;
  }

  .el-pagination /deep/ .number.active {
    color: #2f69ee !important;
  }

  .el-pagination.is-background /deep/ .number.active {
    border: 1px solid #2f69ee !important;
    color: #fff !important;
    background-color: #2f69ee !important;
  }

  /deep/ .btn-prev:not([disabled]):hover,
  /deep/ .btn-next:not([disabled]):hover,
  /deep/ .number:not(.active):hover,
  /deep/ .el-icon.more:hover {
    color: #2f69ee !important;
  }

  .el-pagination.is-background /deep/ .btn-prev:not([disabled]):hover,
  .el-pagination.is-background /deep/ .btn-next:not([disabled]):hover,
  .el-pagination.is-background /deep/ .number:not(.active):hover,
  .el-pagination.is-background /deep/ .el-icon.more:hover {
    border: 1px solid #2f69ee !important;
    color: #2f69ee !important;
  }

  /deep/ .el-pager .more::before {
    line-height: 28px !important;
  }

  &-box {
    display: inline-block !important;
    margin-left: 15px !important;
    font-size: 14px !important;
    line-height: 28px !important;
    font-weight: 400 !important;
    color: #636363 !important;
    -webkit-user-select: none !important;
    -moz-user-select: none !important;
    -ms-user-select: none !important;
    user-select: none !important;

    i:first-of-type {
      font-size: 13px !important;
      font-weight: 600 !important;
      color: #4c4c4c !important;
    }

    i:last-of-type {
      font-size: 13px !important;
      font-weight: 600 !important;
      color: #5f5f5f !important;
    }
  }
}
</style>
